import { ArtData } from '@/database/art'
import React, { ReactElement } from 'react'
import { shortenAddress } from '@/utils/shortenAddress'
import { Tooltip } from 'react-tooltip'
import { VoteData } from '@/database/vote'

const VotesTooltip = ({ artData }: { artData: ArtData }): ReactElement => {
    return (
        <Tooltip anchorSelect={'#votes' + artData.art.id} clickable>
            <div>
                {artData.votes.map((voteData: VoteData) => (
                    <p key={'#p-votes' + voteData.vote.id}>
                        {shortenAddress(voteData.user.walletAddress)}
                        <span className="gray">&nbsp;voted&nbsp;</span>
                        {voteData.vote.amount}
                    </p>
                ))}
            </div>
        </Tooltip>
    )
}

export default VotesTooltip
